import { render, staticRenderFns } from "./DeployCommunityToken.vue?vue&type=template&id=343587e0&scoped=true&"
import script from "./DeployCommunityToken.vue?vue&type=script&lang=js&"
export * from "./DeployCommunityToken.vue?vue&type=script&lang=js&"
import style0 from "./DeployCommunityToken.vue?vue&type=style&index=0&id=343587e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343587e0",
  null
  
)

export default component.exports